import styled from "styled-components"
import { FormSearch } from "../../../../../../../_webui/layout/components/Form/Search"

const StyledFormSearch = styled(FormSearch)`
  .ant-form-horizontal {
    .ant-form-item-label {
      width: 200px;
    }
  }
  .ant-select-disabled .ant-select-selection-item,
  .ant-input-disabled {
    pointer-events: none;
    text-indent: -1000px;
  }
`

export const Styled = {
  StyledFormSearch,
}
